import { assets } from "$app/paths";

function getAsset(pathname: string) {
	return `${assets}/${pathname}`;
}

export { getAsset };
